import api from '../common/helpers/apiHelper';
import { IContact } from '../common/models/contact/IContact';
import { IContactFilter } from '../common/models/filter/IContactFilter';
import { IListData } from '../common/models/common/IListData';
import { ICandidateScore } from '../common/models/candidate/ICandidateScore';
import { mapSortToSortReq, mapFilterToFilterReq } from '../common/helpers/filterHelper';
import { IRefReqContactFilter } from '../common/models/filter/IRefReqContactFilter';
import { IRefReqContact } from '../common/models/contact/IRefReqContact';
import { IContactPhoneNumber } from '../common/models/candidate/ICandidatePhoneNumber';
import { key, getCode } from '../common/helpers/common';
import { ICheckContactInfo } from '../common/models/contact/ICheckContactInfo';
import { IUpdateContact } from '../common/models/contact/IUpdateContact';
import { IMergeContact } from '../common/models/contact/IMergeContact';

export const getContactById = (payload: string) => api.get<IContact>(`/api/contacts/${payload}`);

export const getByContactId = (filter: IContactFilter) => api.get<ICandidateScore[]>(
  `/api/contacts/${filter.id}/candidates`,
  { ...filter, sort: mapSortToSortReq(filter.sort), filter: mapFilterToFilterReq(filter.filter) }
);

export const getAllContacts = (payload: IRefReqContactFilter) => api.get<IListData<IRefReqContact[]>>(
  '/api/contacts',
  payload
);

export const addPhoneNumber = (payload: IContactPhoneNumber) => (
  api.put(`/candidate-api/phone?key=${key}&code=${getCode()}`, payload)
);

export const checkRefPhoneNumber = (phoneNumber: string) => (
  api.get<{ isValid: boolean }>('/candidate-api/phone', { key, code: getCode(), phoneNumber })
);

export const checkPhoneNumber = (phoneNumber: string) => (
  api.get<{ isValid: boolean }>('/api/contacts/check/phone', { phoneNumber })
);

export const checkContactInfo = (payload: ICheckContactInfo) => (
  api.get<{ isValid: boolean }>('/api/contacts/check', payload)
);

export const getContactIfExists = (payload: ICheckContactInfo) => (
  api.get<undefined | IRefReqContact>('/api/contacts/check/ref-req', payload)
);

export const updateContact = (payload: IUpdateContact) => api.put<void>('/api/contacts', payload);

export const mergeContacts = (payload: IMergeContact) => api.post<void>('/api/contacts/merge', payload);
